<template>
  <div class="activity">
    <ActivityCard />
    <Comments />
  </div>
</template>

<script>
import ActivityCard from '@/components/ActivityCard.vue'
import Comments from '@/components/Comments.vue'

export default {
  name: 'Activity',
  components: {
    ActivityCard,
    Comments
  }
}
</script>